import { Target, Building2, Network, Users, TrendingUp } from "lucide-react";

const values = [
  {
    icon: Target,
    title: "Execution-Focused Insights",
    description:
      "Practical, actionable knowledge from real-world institutional operations",
  },
  {
    icon: Building2,
    title: "Institutional Frameworks",
    description:
      "Battle-tested systems and processes used by leading capital market organizations",
  },
  {
    icon: Network,
    title: "Ecosystem Collaboration",
    description:
      "Access to a network of professionals, institutions, and industry experts",
  },
  {
    icon: Users,
    title: "Leadership Interaction",
    description:
      "Direct engagement with experienced practitioners and industry leaders",
  },
  // {
  //   icon: TrendingUp,
  //   title: "Clear Long-Term Pathways",
  //   description:
  //     "Structured opportunities for professional growth and institutional partnership",
  // },
];

export default function WhatMakesValuable() {
  return (
    <section
      className="relative py-16 md:py-20 px-6 md:px-12 lg:px-24
      bg-gradient-to-b from-white via-[#F8FAFC] to-white overflow-hidden"
    >
      {/* subtle brand glow */}
      <div className="absolute top-40 inset-x-0 h-[420px] bg-[#0E6F7E]/5 blur-3xl"></div>

      <div className="container mx-auto max-w-7xl relative z-10">
        {/* Heading */}
        <div className="text-center mb-16">
          <div className="h-1 w-16 bg-gradient-to-r from-[#D4AF37] to-[#C9A631] mx-auto mb-6"></div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#07162E] mb-6">
            What Makes This Program Valuable
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Beyond theory, beyond credentials—real value for capital market
            professionals
          </p>
        </div>

        {/* 2-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {values.map((value, index) => (
            <div
              key={index}
              className="group bg-white/80 backdrop-blur-xl
              rounded-2xl p-8
              shadow-[0_20px_50px_rgba(2,8,23,0.08)]
              hover:shadow-[0_30px_70px_rgba(2,8,23,0.15)]
              transition-all duration-300 transform hover:-translate-y-2
              border-l-4 border-[#0E6F7E]"
            >
              <div className="flex items-start gap-5">
                {/* Icon */}
                <div
                  className="flex-shrink-0 w-14 h-14 rounded-xl
                  bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
                  flex items-center justify-center
                  group-hover:scale-110 group-hover:rotate-3
                  transition-all duration-300"
                >
                  <value.icon className="w-7 h-7 text-[#1DBF73]" />
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-xl font-bold text-[#07162E] mb-2">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-base md:text-lg">
                    {value.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
